// @ts-strict-ignore
import React, { useEffect, useState } from 'react'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'
import { Select } from '@/shared/ui'

import { RegionSelectorProps } from '../../RegionSelector'

import cl from './product-region-select.module.scss'

/**
 * Region select in product page
 * @param activeRegion
 * @param regions
 * @param changeHandler
 */
export const ProductRegionSelect = ({ activeRegion, regions, changeHandler }: RegionSelectorProps): JSX.Element => {
	const [isClient, setIsClient] = useState(false) // Флаг клиентской стороны

	// Устанавливаем флаг, когда компонент монтируется на клиенте
	useEffect(() => {
		setIsClient(typeof window !== 'undefined')
	}, [])

	// Обработчик смены региона
	const handleRegionChange = (value: string) => {
		if (value === activeRegion.REGION_CODE) return // Не переходим, если регион не изменился
		if (isClient) {
			const newUrl = changeHandler(value) // Вызываем getRegionDomain
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			window.location.href = newUrl // Автоматический переход
		}
	}

	const regionValues = regions.map(item => {
		return {
			value: item.REGION_CODE,
			label: item.REGION_CODE === `spb` ? `Санкт-Петербурге и ЛО ` : item.REGION_P_NAME
		}
	})

	return (
		<>
			<Select
				className={cl.select}
				options={regionValues}
				value={activeRegion.REGION_CODE}
				onChange={handleRegionChange}
				isClear
				hideIcon>
				{' '}
				<SvgArrowDown color="#568dfe" size={28} />
			</Select>
		</>
	)
}
